import { createFileRoute, Outlet } from '@tanstack/react-router';
import * as React from 'react';

import { IntercultureResultsPage } from '@interculture';

export const Route = createFileRoute(
  '/_app/interculture_/$crop/$formId/result',
)({
  component: IntercultureResultsPage,
});
